import { NgModule } from '@angular/core';
import { LandingPageRoutes } from './landing-page.routing';
import { LandingPageComponent } from './landing-page.component';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { KpiInsightsConfigComponent } from '../kpi-insights-config/kpi-insights-config.component';
import { PredictiveFailureConfigComponent } from '../predictive-failure-config/predictive-failure-config.component';
import { ClickOutsideDirective } from 'src/app/core/directives/click-outside.directive';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ParcelModule } from 'single-spa-angular/parcel';
import { SharedModule } from 'src/app/shared/shared.module';
import { KpiSelectionPopupComponent } from '../kpi-insights-config/kpi-selection-popup/kpi-selection-popup.component';
import { ShortenPipe } from 'src/app/shared/pipes/shorten.pipe';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { PredictiveAlgorithmComponent } from '../predictive-failure-config/components/predictive-algorithm/predictive-algorithm.component';
import { PredictiveAssetSelectionComponent } from '../predictive-failure-config/components/predictive-asset-selection/predictive-asset-selection.component';
import { PredictiveConfigurationComponent } from '../predictive-failure-config/components/predictive-configuration/predictive-configuration.component';
import { PredictiveImpactedKpiComponent } from '../predictive-failure-config/components/predictive-impacted-kpi/predictive-impacted-kpi.component';
import { SearchDropdownComponent } from 'src/app/shared/components/search-dropdown/search-dropdown.component';
import { AssetImageUrlPipe } from 'src/app/shared/pipes/assetImageUrl.pipe';
import { PreventInputDirective } from 'src/app/shared/directives/prevent-input/prevent-input.directive';
import { ImpactedKpiSelectionPopupComponent } from '../predictive-failure-config/components/predictive-impacted-kpi/impacted-kpi-selection-popup/impacted-kpi-selection-popup.component';
import { AssetSelectionPopupComponent } from '../predictive-failure-config/components/predictive-asset-selection/asset-selection-popup/asset-selection-popup.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { KpiSelectionValidationPopupComponent } from '../kpi-insights-config/kpi-selection-validation-popup/kpi-selection-validation-popup.component';
import { MatMenuModule } from '@angular/material/menu';
import { DeleteConfigurationPopupComponent } from '../dashboard/delete-configuration-popup/delete-configuration-popup.component';
import { EwbConfigComponent} from '../ewb-configuration/ewb-config.component';
import { EwbAlgorithmComponent } from '../ewb-configuration/components/ewb-algorithm/ewb-algorithm.component';
import { EwbAssetSelectionComponent } from '../ewb-configuration/components/ewb-asset-selection/ewb-asset-selection.component';
import { EwbAssetSelectionPopupComponent } from '../ewb-configuration/components/ewb-asset-selection/ewb-asset-selection-popup/ewb-asset-selection-popup.component';
import { EwbConfigurationComponent } from '../ewb-configuration/components/ewb-configuration/ewb-configuration.component';
import { EwbImpactedKpiComponent } from '../ewb-configuration/components/ewb-impacted-kpi/ewb-impacted-kpi.component';
import { EwbImpactedKpiSelectionPopupComponent } from '../ewb-configuration/components/ewb-impacted-kpi/ewb-impacted-kpi-selection-popup/ewb-impacted-kpi-selection-popup.component';

@NgModule({
  imports: [
    LandingPageRoutes,
    CommonModule,
    ParcelModule,
    SharedModule,
    OverlayModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatStepperModule,
    MatTabsModule,
    MatTreeModule,
    CurrencyMaskModule,
    MatMenuModule
  ],
  declarations: [
    TooltipDirective,
    LandingPageComponent,
    HeaderComponent,
    KpiInsightsConfigComponent,
    PredictiveFailureConfigComponent,
    ClickOutsideDirective,
    DashboardComponent,
    KpiSelectionPopupComponent,
    ShortenPipe,
    PredictiveAlgorithmComponent,
    PredictiveAssetSelectionComponent,
    PredictiveConfigurationComponent,
    PredictiveImpactedKpiComponent,
    SearchDropdownComponent,
    ImpactedKpiSelectionPopupComponent,
    AssetSelectionPopupComponent,
    AssetImageUrlPipe,
    PreventInputDirective,
    KpiSelectionValidationPopupComponent,
    DeleteConfigurationPopupComponent,
    EwbConfigComponent,
    EwbAlgorithmComponent,
    EwbAssetSelectionComponent,
    EwbAssetSelectionPopupComponent,
    EwbConfigurationComponent,
    EwbImpactedKpiComponent,
    EwbImpactedKpiSelectionPopupComponent
  ],
  exports: [
    TooltipDirective,
    SearchDropdownComponent
  ]
})
export class LandingPageModule {}
